module.exports = __webpack_public_path__ + "static/img/6.d7543f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/eng/6.png
// module id = UZzA
// module chunks = 0